import React, { useState, useEffect } from 'react'
import './styles/Table.css'
import MaterialTable from 'material-table'
// import GetAppIcon from '@material-ui/icons/GetApp'
// import FileUploadIcon from '@mui/icons-material/FileUpload'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { Grid } from '@material-ui/core'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

// importamos el contexto para extraer la data de ahi
// import { useIFIModule } from '../../../../../context/IFIContext'
// import { useForm } from '../../../../../context/formContext'
// import { makeStyles } from '@material-ui/core/styles'
import ROUTES from '../../../../../routers/routes'
import { useHistory } from 'react-router-dom'
import { useAuthentication } from '../../../../../context/authenticationContext'
import {
  getSentFormsByUser,
  getPrelegibilitySummary,
} from '../../../../../services/Elegibilidad/get'

const TableFormularios = () => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // setLoading(true)
    getInProcessForms()
  }, [])

  const getInProcessForms = async () => {
    // Esto se debe de cambiar en el AutenticationContext con el userID
    // const id = '5f6c28c5-62f8-4a84-ba26-b55e319d440f'
    try {
      const response = await getSentFormsByUser(userIDB2C)
      if (response.Success) {
        if (response.Data.length > 0) {
          setTableForms(response.Data)
        } else {
          setTableForms([])
        }
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
    setLoading(false)
  }

  const getSummary = async (idform) => {
    try {
      const response = await getPrelegibilitySummary(idform)
      if (response.Success) {
        history.push(ROUTES.DETALLES.pathname, response.Data)
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
    setLoading(false)
  }

  const columns = [
    // {
    //   title: 'IdForm',
    //   field: 'IdForm',
    //   sorting: true,
    //   filtering: true,
    //   // cellStyle: { background: '#009688' },
    //   // headerStyle: { color: '#fff' },
    // },
    {
      title: 'Fecha',
      field: 'Fecha_Creación',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'date',
    },
    {
      title: 'Número de formulario',
      field: 'AtNumber',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Formulario',
      field: 'FormType',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Estado del formulario',
      field: 'Estado',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Código Proyecto',
      field: 'Código_Proyecto',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Nombre del Proyecto',
      field: 'Nombre_del_Proyecto',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },

    {
      title: 'Etapa del formulario',
      field: 'Etapa',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'MIPYME',
      field: 'Nombre_MIPYME',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Condición MIPYME',
      field: 'MipymeCondition',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'IFI',
      field: 'IFI',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
  ]
  // downloadPDF, loadingPDF
  // const { deleteDraftForms } = useForm()
  const history = useHistory()
  const [TableForms, setTableForms] = useState([])
  const { userIDB2C } = useAuthentication()

  const openForm = (idForm, formStage) => {
    if (
      idForm !== '' &&
      idForm !== null &&
      idForm !== undefined &&
      formStage === 'Formulario Pre-Elegibilidad'
    ) {
      getSummary(idForm)

      // history.push(ROUTES.DETALLES.pathname, idForm)
    }
    if (
      idForm !== '' &&
      idForm !== null &&
      idForm !== undefined &&
      formStage === 'Formulario Elegibilidad'
    ) {
      // setIdEditForm(idForm)
      // getEditFormElegibility(idForm)
      // if (getEditFormElegibility) {
      // }
      history.push(ROUTES.DETALLESELEGIBILIDAD.pathname, idForm)
    }
    // if (
    //   idForm !== '' &&
    //   idForm !== null &&
    //   idForm !== undefined &&
    //   formStage === 'Formulario Asistencia Tecnica'
    // ) {
    //   history.push(ROUTES.EDITARELEGIBILIDAD.pathname, idForm)
    // }
    if (
      idForm !== '' &&
      idForm !== null &&
      idForm !== undefined &&
      (formStage === 'Asistencia Técnica para Preinversión MIPYME' ||
        formStage ===
          'Asistencia Técnica para Construcción de Capacidades MIPYME' ||
        formStage === 'Asistencia Técnica para Construcción de Capacidades IFI')
    ) {
      history.push(ROUTES.ASISTENCIATECNICAENVIADOS.pathname, idForm)
    }
  }

  return (
    <section>
      {!loading ? (
        <Grid
          container
          style={{
            width: '100%',
            height: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              height: 'auto',
              width: '96%',
              backgroundColor: '#fff',
              borderRadius: '4px',
            }}
          >
            <div className="App">
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <MaterialTable
                    columns={columns}
                    data={TableForms}
                    actions={[
                      {
                        icon: () => <VisibilityIcon color="success" />,
                        tooltip: 'Ver Formulario',
                        onClick: (event, rowData) => {
                          openForm(rowData.IdForm, rowData.FormType)
                        },
                      },

                      // {
                      //   icon: () => <FileUploadIcon color="success" />,
                      //   tooltip: 'Activar Usuario',
                      //   onClick: (event, rowData) => {
                      //     Swal.fire({
                      //       title: '¿Está seguro de activar el usuario?',
                      //       icon: 'warning',
                      //       showCancelButton: true,
                      //       confirmButtonText: 'Si',
                      //       cancelButtonText: 'No',
                      //       dangerMode: true,
                      //     }).then((result) => {
                      //       if (result.isConfirmed) {
                      //         handleEnableUser(rowData.IdUser)
                      //       }
                      //     })
                      //   },
                      // },
                    ]}
                    onSelectionChange={(selectedRows) =>
                      console.log(selectedRows)
                    }
                    options={{
                      sorting: true,
                      search: true,
                      searchFieldAlignment: 'right',
                      searchAutoFocus: true,
                      searchFieldVariant: 'standard',
                      filtering: true,
                      paging: true,
                      pageSizeOptions: [2, 5, 10, 20],
                      pageSize: 5,
                      paginationType: 'stepped',
                      showFirstLastPageButtons: false,
                      paginationPosition: 'bottom',
                      exportButton: true,
                      exportAllData: true,
                      exportFileName:
                        'BCIE - Cambio II                     Consulta Formularios',
                      // addRowPosition: 'first',
                      actionsColumnIndex: -1,
                      selection: false,
                      showSelectAllCheckbox: false,
                      showTextRowsSelected: false,
                      selectionProps: (rowData) => ({
                        disabled: rowData.age == null,
                      }),
                      rowStyle: (data, index) =>
                        index % 2 === 0 ? { background: '#f5f5f5' } : null,
                      headerStyle: { background: '#014b96', color: '#fff' },
                    }}
                    localization={{
                      body: {
                        editRow: {
                          deleteText: '¿Está seguro de eliminar el registro?',
                        },
                        emptyDataSourceMessage: 'No hay registros a desplegar',
                      },
                      header: {
                        actions: 'Acciones',
                      },
                      toolbar: {
                        searchPlaceholder: 'Buscar',
                      },
                    }}
                    title=" "
                  />
                </Grid>
              </Grid>
            </div>
          </div>
        </Grid>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </section>
  )
}
export default TableFormularios
